import { PatientsService } from './../@core/backend/common/services/CalorieFriend/patients.service';
import { ChatModule } from './../@chat/chat.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NbMenuModule,
  NbDialogModule,
  NbUserModule,
  NbCardModule,
  NbButtonModule,
  NbInputModule,
  NbSelectModule,
  NbSidebarModule,
} from '@nebular/theme';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { AuthModule } from 'app/@auth/auth.module';
import { ThemeModule } from 'app/@theme/theme.module';
import { PagesRoutingModule } from './pages-routing.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';

import { PagesMenu } from './pages-menu';
import { PagesComponent } from './pages.component';
import { AppSettingsService } from 'app/@core/backend/common/services/appSettings.service';
import { AppSettingsData } from 'app/@core/interfaces/common/appSettings';
import { CommonBackendModule } from 'app/@core/backend/common/common-backend.module';
import { AppSettingsApi } from 'app/@core/backend/common/api/appSettings.api';

const NB_MODULES = [
  NbDialogModule.forChild(),
  NbUserModule,
  NbMenuModule,
  NbCardModule,
  NbButtonModule,
  NbInputModule,
  NbSelectModule,
  NbSidebarModule,
];

const PAGES_COMPONENTS = [PagesComponent];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...NB_MODULES,

    PagesRoutingModule,
    ThemeModule,
    AuthModule,
    MiscellaneousModule,
    NgxIntlTelInputModule,
    ChatModule,
    CommonBackendModule,
  ],
  declarations: [...PAGES_COMPONENTS],
  providers: [PagesMenu, PatientsService, AppSettingsApi, AppSettingsService
  ],
})
export class PagesModule {}
